export const EXPERIENCE_DNA_CATEGORIES = [
  { id: 'food', label: 'Food', icon: 'mdi-silverware-fork-knife' },
  { id: 'adventure', label: 'Adventure', icon: 'mdi-compass-outline' },
  { id: 'family', label: 'Family', icon: 'mdi-human-male-female-child' },
  { id: 'nightlife', label: 'Nightlife', icon: 'mdi-music-note' },
  { id: 'nature', label: 'Nature', icon: 'mdi-pine-tree' },
  { id: 'culture', label: 'Culture', icon: 'mdi-theater' },
  { id: 'relaxation', label: 'Relaxation', icon: 'mdi-weather-sunset' },
  { id: 'luxury', label: 'Luxury', icon: 'mdi-star-outline' },
];

export const CONFERENCE_DNA_CATEGORY = {
  id: 'conference', label: 'Conference', icon: 'mdi-presentation',
};

const clampScore = (score) => Math.min(100, Math.max(0, Number(score) || 0));

export const normalizeExperienceDNA = (items = [], { includeConference = false } = {}) => {
  const scores = new Map((items || []).map((item) => [item.id, item.score]));

  if (!scores.has('conference') && scores.has('learning')) {
    scores.set('conference', scores.get('learning'));
  }

  const categories = includeConference
    ? [...EXPERIENCE_DNA_CATEGORIES, CONFERENCE_DNA_CATEGORY]
    : EXPERIENCE_DNA_CATEGORIES;

  return categories.map((category) => ({
    ...category,
    score: clampScore(scores.get(category.id)),
  }));
};

export const experienceDNAFromFivePointScale = (scores = {}, options = {}) => (
  normalizeExperienceDNA(
    Object.entries(scores || {}).map(([id, score]) => ({ id, score: Number(score) * 20 })),
    options,
  )
);
